<template>
  <StateWrapper
    :contentObject="chat"
    :loadingStatus="loadingStatus"
    :checkLogin="true"
  >
    <UserContentWrapper
      :title="chat.title"
      @back="router.push({ path: '/user/bot' })"
      class="user-salon"
    >
      <v-btn
        variant="outlined"
        class="text-indigo-lighten-1 ma-2"
        @click="router.push({ path: '/user/bot' })"
      >
        {{ t('chat.back') }}
      </v-btn>

      <v-card variant="outlined" class="ma-2 pa-4 chat-main" id="chat_window">
          <!-- Empty chat state -->
          <v-card variant="outlined" v-if="chat.history.length === 0 && !sendDisabled">
            <p class="pa-4 ma-2">{{ t('chat.empty') }}</p>
          </v-card>
          <!-- Chat s -->
          <div v-else>
            <div
              v-for="msg in chat.history"
              :key="msg.id"
              :class="{ 'd-flex flex-row-reverse': msg.role === 'USER' }"
            >
              <v-card
                :color="msg.role === 'USER' ? '#514ca1' : '#fc8695'"
                variant="outlined"
                style="height:auto;white-space: normal;"
                class="pa-4 ma-2"
              >
                <template v-slot:title>
                     <v-row v-if="msg.role === 'USER'">
                                          <div class="d-flex align-center">
                                               <div class="n-avatar ma-4">
                                                   <AppImage v-if="user.personAvatar" :image="`https://navigator-backend.eurekacenter.ru/api/download/avatar/user/${user.personAvatar}`" />
                                                   <div v-else class="n-avatar__pseudo-avatar">
                                                       <AppIcon icon="bot-icon" />
                                                   </div>
                                               </div>
                                              <h3 class="mt-4 mb-4">
                                                {{ t('chat.you') }}
                                              </h3>
                                          </div>
                                      </v-row>
                                      <v-row v-else >
                                          <div class="d-flex align-center">
                                            <div  class="n-avatar ma-4">
                                                <div class="n-avatar__pseudo-avatar">
                                                    <AppIcon icon="bot-icon" />
                                                </div>
                                            </div>
                                            <h3 class="mt-4 mb-4">
                                                {{ t('bot') }}
                                            </h3>
                                          </div>
                                      </v-row>
                </template>
                <p class="pa-4 ma-2" v-if="msg.content">
                  <VMarkdownView :mode="mode" :content="msg.content"></VMarkdownView>
                </p>
                <sub v-if="msg.createdAt" class="ml-2">
                  {{ formatDate(msg.createdAt) }}
                </sub>
              </v-card>
            </div>
            <!-- Pending user message -->
            <div v-if="sendDisabled">
              <div class="d-flex flex-row-reverse">
                <v-card
                  :color="'#514ca1'"
                  :title="t('chat.you')"
                  variant="outlined"
                  style="height:auto;white-space: normal;"
                  class="pa-4 ma-2"
                >
                  <p class="pa-4 ma-2" v-if="messageInput && messageInput.length > 0">
                    <VMarkdownView :mode="mode" :content="capitalizeFirstLetter(messageInput)"></VMarkdownView>
                  </p>
                </v-card>
              </div>
            </div>
            <!-- Pending bot response -->
            <div v-if="sendDisabled">
              <div class="d-flex">
                <v-card
                  :color="'#fc8695'"
                  :title="t('bot')"
                  variant="outlined"
                  style="height:auto;white-space: normal;"
                  class="pa-4 ma-2"
                >
                  <v-row
                    align-content="center"
                    class="fill-height"
                    justify="center"
                  >
                    <v-col
                      class="text-center"
                      cols="12"
                    >
                    Думаю над вопросом
                    </v-col>
                    <v-col cols="12">
                      <v-progress-linear
                        color="deep-pink-accent-4"
                        height="6"
                        indeterminate
                        rounded
                      ></v-progress-linear>
                    </v-col>
                    <v-col cols="12">
                      <VMarkdownView class="ma-2 pa-2" :mode="mode" :content="fullText"></VMarkdownView>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
            </div>
          </div>
      </v-card>
      
      <!-- Message input -->
      <div class="message-input-container ma-2">
        <v-textarea
          v-model="messageInput"
          variant="outlined"
          :placeholder="t('chat.type_message')"
          :hint="t('chat.type_message_hint')"
          :disabled="sendDisabled"
          rows="3"
          auto-grow
          clearable
          @keyup.enter="sendMessage"
        />
        <v-btn
          variant="outlined"
          class="text-indigo-lighten-1 mt-2"
          @click="sendMessage"
          :disabled="sendDisabled || !messageInput.trim()"
        >
          {{ t('send') }}
        </v-btn>
      </div>
    </UserContentWrapper>
  </StateWrapper>

</template>

<script>
import { t } from "@/utils/translate";
import { capitalizeFirstLetter } from "@/utils/common";
import UserContentWrapper from "@/elements/UserContentWrapper.vue";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import StateWrapper from "@/components/StateWrapper.vue";
import { botApiUrl} from "@/service/user.service"
import AppImage from "@/elements/AppImage.vue";
import AppIcon from "@/elements/AppIcon.vue";
import personAvatar from "@/store/userStore"
import { useUserStore } from "@/store/userStore";
import { VMarkdownView } from 'vue3-markdown'
import { storeToRefs } from "pinia";
import { customStorage } from "@/service/customStorage";
import { usePopupStore } from "@/store/popupStore";
import { customAxios } from "@/service/customAxios";
import { onMounted, ref , watch, onUpdated} from "vue";


export default {
  components: {
    UserContentWrapper,
    VMarkdownView,
    AppImage,
    AppIcon,
    StateWrapper

  },
  setup() {
    const store = useUserStore();
    const { user } = storeToRefs(store);
    const route = useRoute();
    const chat = ref();
    const loadingStatus = ref("loading");
    const mode = ref('light')
    const messageInput = ref("");
    const sendDisabled = ref(false);
    const router = useRouter();
    const fullText = ref("");
    const popupStore = usePopupStore();
    const { showPopup } = popupStore;



watch(() => fullText.value, () => {
  dropDown();
}, { deep: true })

watch(() => chat.value, () => {
  dropDown();
}, { deep: true })

watch(() => messageInput.value, () => {
  messageInput.value = capitalizeFirstLetter(messageInput.value);
}, { deep: true })

   const dropDown = () => {
      const chatContainer = document.getElementById("chat_window");
      if (chatContainer) {
        chatContainer.scrollTop = chatContainer.scrollHeight;
      }
    };
onUpdated(dropDown);

function formatDate(dateString) {
      let formatter = new Intl.DateTimeFormat("ru", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      });
      return capitalizeFirstLetter(formatter.format(Date.parse(dateString)));
}
    async function sendMessage() {
      sendDisabled.value=true;
      fullText.value='';
      setTimeout(() => {
        dropDown();
      }, 500);
    
      try {
        sendDisabled.value=true;
        const url = `${botApiUrl}/chat-stream/${route.params.id}?userPrompt=${encodeURIComponent(messageInput.value)}&token=${encodeURIComponent(customStorage.get("user-token"))}`;
        const eventSource = new EventSource(url)
        eventSource.onmessage = function(event) {
          const data = JSON.parse(event.data);
          if(data && data.statusCode && data.statusCode.includes('CREATED')){
            eventSource.close();
            getMyChat();
            sendDisabled.value=false;
            messageInput.value = ''
          } else if(data && data.statusCode && data.statusCode ==="SERVICE_UNAVAILABLE"){
            showPopup(data.body.message, "error");
            eventSource.close();
            dropDown();
            sendDisabled.value=false;
          } else {
            let token = data.text;
            fullText.value += token;
            dropDown();
          }
        }
        eventSource.onerror = function(event) {
          if (event.currentTarget.readyState === EventSource.CLOSED) {
            console.log("SSE connection was closed gracefully.");
            eventSource.close();
            getMyChat();
            sendDisabled.value=false;
            messageInput.value = '';
            setTimeout(() => {
              dropDown();
            }, 500);
          } else {
            console.error("SSE error:", event);
            eventSource.close();
            getMyChat();
            sendDisabled.value=false;
            messageInput.value = '';
          }
        }
      } catch (e) {
        console.log(e);
      } 
    }

    async function getMyChat() {
      if(!route.params.id){
          return
      }
      try {
        const r = await customAxios.getExternal(`${botApiUrl}/api/chat/${route.params.id}`);
        if(r.status===200){
          loadingStatus.value = "loaded";
          chat.value =  r.data;
          setTimeout(() => {
            dropDown();
          }, 500);
        }
      } catch (e) {
        if(e.code==="ERR_NETWORK"){
          showPopup("Чат временно не доступен! Попробуйте обновить страницу, либо зайти позже.", "error");
        }
      } finally {
        dropDown();
      }
    }

    onMounted(async () => {
     await getMyChat();
    });

    return {
      loadingStatus,
      chat,
      t,
      mode,
      messageInput,
      sendMessage,
      sendDisabled,
      formatDate,
      router,
      fullText,
      personAvatar,
      user,
      capitalizeFirstLetter
    };
  },
};
</script>

<style lang="scss">

.chat-main {
  height: 600px;
  overflow-y: auto;
}

.message-input-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.message-input-container v-textarea {
  flex: 1;
}

.markdown-body {
  
  margin: 0;
     margin: 0;
  color: #333;
    font-size: 18px;
    line-height: 22px;
    font-family: "Comfortaa", sans-serif;
    font-weight: 700;
}


</style>
